import { render, staticRenderFns } from "./createDetail.vue?vue&type=template&id=3da010b0&scoped=true&"
import script from "./createDetail.vue?vue&type=script&lang=js&"
export * from "./createDetail.vue?vue&type=script&lang=js&"
import style0 from "./createDetail.vue?vue&type=style&index=0&id=3da010b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da010b0",
  null
  
)

export default component.exports